import { mapActions, mapState } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';
import { snakeCase } from 'lodash';
import externalLinksMixin from '@/mixins/externalLinks';
import ls from '@/helpers/localStorage';

const PROVIDER_FACEBOOK = 'Facebook';
const PROVIDER_TWITTER = 'Twitter';
const CACHE_NAME = 'register-external';

export default {
  mixins: [
    formMixin,
    externalLinksMixin,
  ],
  validations: {
    fields: {
      email: validators.email,
      emailConfirmation: validators.emailConfirmation('email'),
      username: validators.username,
    },
  },
  data() {
    return {
      fields: {
        email: '',
        emailConfirmation: '',
        username: '',
      },
      error: null,
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapState('popup', ['formDataCache']),
  },
  mounted() {
    if (this.userInfo && this.userInfo.userName) {
      this.fields.username = snakeCase(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = {
        ...this.fields,
        ...this.formDataCache,
      };
    }
    if (this.fields.email) {
      this.$v.fields.email.$touch();
    }
    if (this.fields.emailConfirmation) {
      this.$v.fields.emailConfirmation.$touch();
    }
  },
  watch: {
    userInfo() {
      this.fields.username = snakeCase(this.userInfo.userName);
      this.$v.fields.username.$touch();
    },
  },
  methods: {
    ...mapActions('user', ['registerExternal']),
    ...mapActions('popup', ['setCurrentPopup', 'cacheFormData']),
    closePopupAndRedirect() {
      this.setCurrentPopup();
      this.getExternalLogins({})
        .then((response) => {
          this.links = response.data;
          const provider = this.userInfo.loginProvider;
          switch (provider) {
            case PROVIDER_FACEBOOK:
              this.facebookLinkClick();
              break;
            case PROVIDER_TWITTER:
              this.twitterLinkClick();
              break;
            default:
              break;
          }
        });
    },
    onSubmit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: 'Create Account',
      });
      if (this.formIsValid() && this.formDisable()) {
        const payload = {
          email: this.fields.email,
          userName: snakeCase(this.fields.username),
        };
        this.registerExternal(payload)
          .then(this.formEnable)
          .then(() => {
            ls.set('registeredExternal', true);
            this.closePopupAndRedirect();
          })
          .catch(error => this.formHandleErrors(error));
      }
    },
  },
  beforeDestroy() {
    this.cacheFormData({ ...this.fields, route: CACHE_NAME });
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-register-external/account-register-external.js